// import logo from './logo.svg';
import './App.css';
import Header from './component/Header';
import Footer from './component/Footer';
import TinderCards from './component/TinderCards';
function App() {
  return (
    <>
    {/*Heading*/}
    <Header/>

    <TinderCards/>
    
    {/*Section*/}


    {/*Footer*/}
    <Footer/>

    </>
  );
}

export default App;
